module.exports = __webpack_public_path__ + "landlord-3-6834e8a8da2a349e87325de37319a173.bundle.svg";